import AllhomesStickyFooter from './allhomes-sticky-footer';
export default AllhomesStickyFooter;